import { render, staticRenderFns } from "./footerElement.vue?vue&type=template&id=51c4eed2&"
import script from "./footerElement.vue?vue&type=script&lang=js&"
export * from "./footerElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports